<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="row">
      <div class="col-lg-5 col-md-5 mb-3">
        <div class="bg-white rounded border px-3 py-3">
          <div v-if="loading">
            <div class="d-flex justify-content-center">
              <div class="spinner-border " role=" status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <select v-model="selectedMenuOption" class="py-2 border border-secondary rounded px-2 me-2 mb-3"
                    style="width: 100%" @change="toggleMenuType">
              <option v-for="(info, index) in menuCategoryTypes" :key="index" :value="info">{{
                  info.menu_name
                }}
              </option>
            </select>
            <!-- update section  -->
            <div v-if="showUpdateSection">
              <h4 class="mb-4">Update This {{ selectedMenuOption.menu_name }}</h4>
              <!-- Link Edit -->
              <div v-if="menuStructure[toUpdateMenuIndex].page_type == 3">
                <div class="main-section d-flex flex-column" style="display: flex">
                  <input v-model="menuStructure[toUpdateMenuIndex].menu_name_bn" class="form-control mb-2"
                         placeholder="Add title"
                         type="text"/>
                  <input v-model="menuStructure[toUpdateMenuIndex].menu_name_en" class="form-control mb-2"
                         placeholder="Add English title"
                         type="text"/>
                  <input v-model="menuStructure[toUpdateMenuIndex].external_link" class="form-control"
                         placeholder="Add a Link"
                         type="text"/>
                </div>

              </div>
              <!-- Page Edit -->
              <div
                  v-else-if="menuStructure[toUpdateMenuIndex].page_type == 2 || menuStructure[toUpdateMenuIndex].page_type == 1">
                <div class="h5 ms-1 mb-3">Categories</div>
                <div v-for="(categoryinfo, index) in subcategoriesInfo" :key="index" class="mx-2 my-2">
                  <div :aria-controls="categoryinfo.categoryId" aria-expanded="false"
                       class="d-grid gap-2" data-bs-toggle="collapse"
                       v-bind:href="'#cat' + categoryinfo.categoryId">
                    <button class="btn btn-outline-dark" type="button">
                      <div class="row justify-content-end">
                        <div class="col-4">
                          {{ categoryinfo.categoryName }} Categories
                        </div>
                        <div class="col-4">
                          <i class="fa-solid fa-chevron-down"></i>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div v-bind:id="'cat' + categoryinfo.categoryId" class="collapse mt-1 mb-2">
                    <div class="border mt-2 ">
                      <ul class="mt-2" style="list-style-type: none">
                        <li v-for="(subCategoryInfo, index) in categoryinfo.subCategories"
                            :key="index">
                          <div class="d-flex flex-row">
                            <input :id="subCategoryInfo.id" v-model="menuStructure[toUpdateMenuIndex].page_type_id"
                                   :value="subCategoryInfo.id"
                                   class="form-check-input" name="flexRadioDefault"
                                   style="width: 15px; height: 15px;"
                                   type="radio"
                                   @click="updateSinglePageSubCategory(subCategoryInfo)">
                            <h5 class="ms-1">
                              {{ subCategoryInfo.name }}
                            </h5>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div v-for="(element, index) in elementsInfo" :key="index" class="mx-2 my-2">
                  <div :aria-controls="element.categoryId" aria-expanded="false"
                       class="d-grid gap-2" data-bs-toggle="collapse"
                       v-bind:href="'#' + element.categoryId">
                    <button class="btn btn-outline-dark" type="button">
                      <div class="row justify-content-end">
                        <div class="col-4">
                          {{ element.categoryName }}
                        </div>
                        <div class="col-4">
                          <i class="fa-solid fa-chevron-down"></i>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div :id="element.categoryId" class="collapse mt-1 mb-2">
                    <div class="border mt-2">
                      <ul class="mt-2" style="list-style-type: none">
                        <li v-for="(elementDetails, index) in element.elements" :key="index">
                          <input :id="elementDetails.id" v-model="menuStructure[toUpdateMenuIndex].page_type_id"
                                 :value="elementDetails.id"
                                 class="form-check-input" name="flexRadioDefault"
                                 style="width: 15px; height: 15px;"
                                 type="radio"
                                 @click="updateSinglePageContent(elementDetails)">
                          <h5 class="ms-1">
                            {{ elementDetails.title }}
                          </h5>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
              <!-- Collection Edit -->
              <div v-else-if="menuStructure[toUpdateMenuIndex].page_type == 4">
                <div class="h6 ms-1 mb-2">Edit this dropdown collection</div>
                <div class="main-section d-flex flex-column" style="display: flex">
                  <input v-model="menuStructure[toUpdateMenuIndex].menu_name_bn" class="form-control mb-2"
                         placeholder="Add Collection title"
                         type="text"/>
                  <input v-model="menuStructure[toUpdateMenuIndex].menu_name_en" class="form-control mb-2"
                         placeholder="Add Collection English title"
                         type="text"/>
                  <div class="btn btn-success btn-sm mb-2" @click="showUpdatePageMenus = !showUpdatePageMenus">
                    Update Single Menus
                  </div>
                  <div class="btn btn-dark btn-sm mb-2" @click="openAddSectionModal">
                    Add a Section
                  </div>
                  <div v-for="(sectionInfo, sectionIndex) in menuStructure[toUpdateMenuIndex].children"
                       :key="sectionIndex">
                    <div v-if="sectionInfo.page_type == 4"
                         class="border rounded border-secondary p-2 mb-2 mx-3 d-flex flex-row align-items-center">
                      <div class="d-flex flex-row mr-auto" style="justify-items: center;align-items: center">
                        <i class="fa-solid fa-layer-group me-2" style="height: 20px"></i>
                        <div class="" style="font-size: 20px">
                          {{ sectionInfo.menu_name_bn }}
                        </div>
                      </div>
                      <div class="btn" @click="selectUpdatableSectionData(sectionInfo)">
                        <i class="fa-solid fa-pen-to-square text-primary"></i>
                      </div>
                      <!--                      <div class="btn" @click="removeSectionFromUpdate(toUpdateMenuIndex,sectionIndex)">-->
                      <!--                        <i class="fa-solid fa-xmark text-danger"></i>-->
                      <!--                      </div>-->
                    </div>
                  </div>
                  <div v-if="showUpdatePageMenus">
                    <div v-for="(categoryinfo, index) in subcategoriesInfo" :key="index"
                         class="mx-2 my-2">
                      <div :aria-controls="categoryinfo.categoryId" aria-expanded="false"
                           class="d-grid gap-2" data-bs-toggle="collapse"
                           v-bind:href="'#cat' + categoryinfo.categoryId">
                        <button class="btn btn-outline-dark" type="button">
                          <div class="row justify-content-end">
                            <div class="col-4">
                              {{ categoryinfo.categoryName }} Categories
                            </div>
                            <div class="col-4">
                              <i class="fa-solid fa-chevron-down"></i>
                            </div>
                          </div>
                        </button>
                      </div>
                      <div v-bind:id="'cat' + categoryinfo.categoryId" class="collapse mt-1 mb-2">
                        <div class="border mt-2">
                          <ul class="mt-2" style="list-style-type: none">
                            <li v-for="(subCategoryInfo, index) in categoryinfo.subCategories"
                                :key="index">
                              <input :id="subCategoryInfo.id" v-model="updatablePagesIds"
                                     :value="subCategoryInfo.id" class="form-check-input"
                                     name="flexRadioDefault" style="width: 15px; height: 15px;"
                                     type="checkbox"
                                     @click="updateCheckBox(subCategoryInfo.id, 'subcat', subCategoryInfo)">
                              <h5 class="ms-1">
                                {{ subCategoryInfo.name }}
                              </h5>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div v-for="(element, index) in elementsInfo" :key="index" class="mx-2 my-2">
                      <div :aria-controls="element.categoryId" aria-expanded="false"
                           class="d-grid gap-2" data-bs-toggle="collapse"
                           v-bind:href="'#' + element.categoryId">
                        <button class="btn btn-outline-dark" type="button">
                          <div class="row justify-content-end">
                            <div class="col-4">
                              {{ element.categoryName }}
                            </div>
                            <div class="col-4">
                              <i class="fa-solid fa-chevron-down"></i>
                            </div>
                          </div>
                        </button>
                      </div>
                      <div :id="element.categoryId" class="collapse mt-1 mb-2">
                        <div class="border mt-2">
                          <ul class="mt-2" style="list-style-type: none">
                            <li v-for="(elementDetails, index) in element.elements"
                                :key="index">
                              <input :id="elementDetails.id" v-model="updatablePagesIds"
                                     :value="elementDetails.id" class="form-check-input"
                                     name="flexRadioDefault" style="width: 15px; height: 15px;"
                                     type="checkbox"
                                     @click="updateCheckBox(elementDetails.id, 'content', elementDetails)">
                              <h5 class="ms-1">
                                {{ elementDetails.title }}
                              </h5>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="btn btn-info btn-sm" @click="addLinkforUpdate()">
                      Add Links
                    </div>
                  </div>
                  <div>
                    <div class="main-section d-flex flex-column" style="display: flex">
                      <div v-for="(linkSection, index) in menuStructure[toUpdateMenuIndex].children"
                           :key="index">
                        <div v-if="linkSection.page_type == 3"
                             class="border border-secondary rounded p-2 mt-2 mb-2">
                          <div>Link</div>
                          <input v-model="linkSection.menu_name_bn" class="form-control mb-2" placeholder="Add title"
                                 type="text"/>
                          <input v-model="linkSection.menu_name_en" class="form-control mb-2"
                                 placeholder="Add English title"
                                 type="text"/>
                          <input v-model="linkSection.external_link" class="form-control" placeholder="Add a Link"
                                 type="text"/>
                          <div class="d-flex flex-row mt-2">
                            <div class="btn btn-secondary me-1 btn-sm"
                                 @click="removeAcollectionLinkDataAtUpdate(linkSection)">
                              Remove
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row mt-4">
                <div class="btn btn-primary me-2" @click="updateNavbarMenus">
                  Update
                </div>
                <div class="btn btn-danger me-1" @click="clearData">
                  Cancel
                </div>
              </div>
            </div>
            <div v-else>
              <!-- ADD section  -->
              <h4 class="mb-4">Add {{ selectedMenuOption.menu_name }}</h4>
              <div v-if="!isAddMenuEnabled">
                <div class="d-grid gap-2 mb-4">
                  <div v-if="this.selectedMenuOption.l_portal_menu_type_id === 1"
                       class="btn btn-outline-primary " @click="toggleMenuEnabled('collection')">
                    Add Dropdown Menu
                  </div>
                  <div v-if="this.selectedMenuOption.l_portal_menu_type_id === 1"
                       class="btn btn-outline-primary " @click="toggleMenuEnabled('page')">
                    Add Single Menu
                  </div>
                  <div class="btn btn-success" @click="toggleMenuEnabled('link')">
                    Add Link Menu
                  </div>
                </div>
              </div>
              <div v-else>
                <!-- page section -->
                <div v-if="showSection === 'page'">
                  <div class="h5 ms-1 mb-3">Categories</div>
                  <div v-for="(categoryinfo, index) in subcategoriesInfo" :key="index" class="mx-2 my-2">
                    <div :aria-controls="categoryinfo.categoryId" aria-expanded="false"
                         class="d-grid gap-2" data-bs-toggle="collapse"
                         v-bind:href="'#cat' + categoryinfo.categoryId">
                      <button class="btn btn-outline-dark" type="button">
                        <div class="row justify-content-end">
                          <div class="col-4">
                            {{ categoryinfo.categoryName }} Categories
                          </div>
                          <div class="col-4">
                            <i class="fa-solid fa-chevron-down"></i>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div v-bind:id="'cat' + categoryinfo.categoryId" class="collapse mt-1 mb-2">
                      <div class="border mt-2">
                        <ul class="mt-2" style="list-style-type: none;">
                          <li v-for="(subCategoryInfo, index) in categoryinfo.subCategories"
                              :key="index">
                            <input :id="subCategoryInfo.id" v-model="selectedElement" :value="subCategoryInfo.id"
                                   class="form-check-input" name="flexRadioDefault"
                                   style="width: 15px; height: 15px;" type="radio"
                                   @click="selectSubCategory(subCategoryInfo)">
                            <h5 class="ms-1">
                              {{ subCategoryInfo.name }}
                            </h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div v-for="(element, index) in elementsInfo" :key="index" class="mx-2 my-2">
                    <div :aria-controls="element.categoryId" aria-expanded="false"
                         class="d-grid gap-2" data-bs-toggle="collapse"
                         v-bind:href="'#' + element.categoryId">
                      <button class="btn btn-outline-dark" type="button">
                        <div class="row justify-content-end">
                          <div class="col-4">
                            {{ element.categoryName }}
                          </div>
                          <div class="col-4">
                            <i class="fa-solid fa-chevron-down"></i>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div :id="element.categoryId" class="collapse mt-1 mb-2">
                      <div class="border mt-2">
                        <ul class="mt-2" style="list-style-type: none">
                          <li v-for="(elementDetails, index) in element.elements" :key="index">
                            <input :id="elementDetails.id" v-model="selectedElement" :value="elementDetails.id"
                                   class="form-check-input" name="flexRadioDefault"
                                   style="width: 15px; height: 15px;" type="radio"
                                   @click="selectContent(elementDetails)">
                            <h5 class="ms-1">
                              {{ elementDetails.title }}
                            </h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-row mt-4">
                    <div class="btn btn-primary me-2" @click="addNavBarMenu('page')">
                      Add
                    </div>
                    <div class="btn btn-danger me-1" @click="toggleMenuEnabled('cancel')">
                      Cancel
                    </div>
                  </div>
                </div>
                <!-- link section -->
                <div v-else-if="showSection === 'link'">
                  <div class="h5 ms-1 mb-2">Add a Link</div>
                  <div class="main-section d-flex flex-column" style="display: flex">
                    <input v-model="requestSaveNavBar.menu_name_bn" class="form-control mb-2" placeholder="Add title"
                           type="text"/>
                    <input v-model="requestSaveNavBar.menu_name_en" class="form-control mb-2"
                           placeholder="Add English title"
                           type="text"/>
                    <input v-model="requestSaveNavBar.external_link" class="form-control" placeholder="Add a Link"
                           type="text"/>
                  </div>
                  <div class="d-flex flex-row mt-4">
                    <div class="btn btn-primary me-2" @click="addNavBarMenu('link')">
                      Add
                    </div>
                    <div class="btn btn-danger me-1" @click="toggleMenuEnabled('cancel')">
                      Cancel
                    </div>
                  </div>
                </div>
                <!-- collection section -->
                <div v-else-if="showSection === 'collection'">
                  <div class="h6 ms-1 mb-2">Add a Dropdown Menu Collection</div>
                  <div class="main-section d-flex flex-column" style="display: flex">
                    <input v-model="requestSaveNavBar.menu_name_bn" class="form-control mb-2"
                           placeholder="Dropdown menu title"
                           type="text"/>
                    <input v-model="requestSaveNavBar.menu_name_en" class="form-control mb-2"
                           placeholder="Dropdown menu English title"
                           type="text"/>
                    <div class="btn btn-success btn-sm mt-2 mb-2" @click="showPage = !showPage">
                      Add Pages
                    </div>
                    <div v-if="showPage">
                      <div v-for="(categoryinfo, index) in subcategoriesInfo" :key="index"
                           class="mx-2 my-2">
                        <div :aria-controls="categoryinfo.categoryId" aria-expanded="false"
                             class="d-grid gap-2" data-bs-toggle="collapse"
                             v-bind:href="'#cat' + categoryinfo.categoryId">
                          <button class="btn btn-outline-dark" type="button">
                            <div class="row justify-content-end">
                              <div class="col-4">
                                {{ categoryinfo.categoryName }} Categories
                              </div>
                              <div class="col-4">
                                <i class="fa-solid fa-chevron-down"></i>
                              </div>
                            </div>
                          </button>
                        </div>
                        <div v-bind:id="'cat' + categoryinfo.categoryId" class="collapse mt-1 mb-2">
                          <div class="border mt-2">
                            <ul class="mt-2" style="list-style-type: none">
                              <li v-for="(subCategoryInfo, index) in categoryinfo.subCategories"
                                  :key="index">
                                <input :id="subCategoryInfo.id" v-model="collectionPagesChildren"
                                       :value="subCategoryInfo"
                                       class="form-check-input"
                                       name="flexRadioDefault"
                                       style="width: 15px; height: 15px;"
                                       type="checkbox">
                                <h5 class="ms-1">
                                  {{ subCategoryInfo.name }}
                                </h5>
                              </li>

                            </ul>
                          </div>
                        </div>
                      </div>
                      <div v-for="(element, index) in elementsInfo" :key="index" class="mx-2 my-2">
                        <div :aria-controls="element.categoryId" aria-expanded="false"
                             class="d-grid gap-2" data-bs-toggle="collapse"
                             v-bind:href="'#' + element.categoryId">
                          <button class="btn btn-outline-dark" type="button">
                            <div class="row justify-content-end">
                              <div class="col-4">
                                {{ element.categoryName }}
                              </div>
                              <div class="col-4">
                                <i class="fa-solid fa-chevron-down"></i>
                              </div>
                            </div>
                          </button>
                        </div>
                        <div :id="element.categoryId" class="collapse mt-1 mb-2">
                          <div class="border mt-2">
                            <ul class="mt-2" style="list-style-type: none">
                              <li v-for="(elementDetails, index) in element.elements"
                                  :key="index">
                                <input :id="elementDetails.id" v-model="collectionPagesChildren"
                                       :value="elementDetails"
                                       class="form-check-input"
                                       name="flexRadioDefault"
                                       style="width: 15px; height: 15px;"
                                       type="checkbox">
                                <h5 class="ms-1">
                                  {{ elementDetails.title }}
                                </h5>

                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mb-2 btn btn-dark btn-sm" @click="openAddSectionModal()">
                      <div>Add a Section</div>
                    </div>
                    <div v-for="(sectionInfo, index) in collectionSectionsChildren" :key="index">
                      <div class="border rounded border-secondary p-2 mb-2 mx-3 d-flex flex-row align-items-center">
                        <div class="mr-auto">
                          {{ sectionInfo.menu_name_bn }}
                        </div>
                        <div class="btn" @click="removeSection(index)">
                          <i class="fa-solid fa-xmark text-danger"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column">
                      <div class="btn btn-info btn-sm" @click="addLink()">
                        <div v-if="collectionLinksChildren.length == 0"> Add a Link</div>
                        <div v-else>Add another Link</div>
                        <!--                        <div>Add a Link</div>-->
                      </div>
                    </div>
                    <div>
                      <div class="main-section d-flex flex-column" style="display: flex">
                        <div v-for="(linkSection, index) in collectionLinksChildren" :key="index">
                          <div class="border border-secondary rounded p-2 mt-2 mb-2">
                            <div>Link {{ index + 1 }}</div>
                            <input v-model="linkSection.menu_name_bn" class="form-control mb-2" placeholder="Add title"
                                   type="text"/>
                            <input v-model="linkSection.menu_name_en" class="form-control mb-2"
                                   placeholder="Add English title"
                                   type="text"/>
                            <input v-model="linkSection.external_link" class="form-control" placeholder="Add a Link"
                                   type="text"/>
                            <div class="d-flex flex-row mt-2">
                              <div class="btn btn-secondary me-1 btn-sm"
                                   @click="removeAcollectionLinkData(index)">
                                Remove
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="d-flex flex-row mt-4">
                    <div class="btn btn-primary me-2" @click="addNavBarMenu('collection')">
                      Add
                    </div>
                    <div class="btn btn-danger me-1" @click="toggleMenuEnabled('cancel')">
                      Cancel
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-row mt-4">
                </div>
              </div>
            </div>
          </div>
          <div v-if="showAddModal">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;"
                 tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add a Section
                    </h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                            type="button" @click="showAddModal = false"></button>
                  </div>
                  <!-- Section Details-->
                  <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                    <div class="main-section d-flex flex-column" style="display: flex">
                      <div class="d-flex flex-row gap-3 mb-2">
                        <div class="d-flex flex-column w-100">
                          <div class="h6 ms-1 mb-2">Section Title</div>
                          <input v-model="addSectionDetails.menu_name_bn" class="form-control mb-2"
                                 placeholder="Section title"
                                 type="text"/>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <div class="h6 ms-1 mb-2">Section English Title</div>
                          <input v-model="addSectionDetails.menu_name_en" class="form-control mb-2"
                                 placeholder="Section English title"
                                 type="text"/>
                        </div>
                      </div>
                      <div class="d-flex flex-row gap-3 w-100">
                        <div class="d-flex flex-column w-100">
                          <div class="btn btn-success btn-sm mb-2"
                               @click="showPageSection = !showPageSection">
                            Add Pages
                          </div>
                          <div v-if="showPageSection">
                            <div v-for="(categoryinfo, index) in subcategoriesInfo" :key="index"
                                 class="mx-2 my-2">
                              <div :aria-controls="categoryinfo.categoryId" aria-expanded="false"
                                   class="d-grid gap-2" data-bs-toggle="collapse"
                                   v-bind:href="'#cat' + categoryinfo.categoryId">
                                <button class="btn btn-outline-dark" type="button">
                                  <div class="row justify-content-end">
                                    <div class="col-4">
                                      {{ categoryinfo.categoryName }} Categories
                                    </div>
                                    <div class="col-4">
                                      <i class="fa-solid fa-chevron-down"></i>
                                    </div>
                                  </div>
                                </button>
                              </div>
                              <div v-bind:id="'cat' + categoryinfo.categoryId" class="collapse mt-1 mb-2">
                                <div class="border mt-2">
                                  <ul class="mt-2" style="list-style-type: none">
                                    <li v-for="(subCategoryInfo, index) in categoryinfo.subCategories"
                                        :key="index">
                                      <input :id="subCategoryInfo.id" v-model="sectionPagesChildren"
                                             :value="subCategoryInfo"
                                             class="form-check-input"
                                             name="flexRadioDefault"
                                             style="width: 15px; height: 15px;"
                                             type="checkbox">
                                      <h5 class="ms-1">
                                        {{ subCategoryInfo.name }}
                                      </h5>
                                    </li>

                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div v-for="(element, index) in elementsInfo" :key="index" class="mx-2 my-2">
                              <div :aria-controls="element.categoryId" aria-expanded="false"
                                   class="d-grid gap-2" data-bs-toggle="collapse"
                                   v-bind:href="'#' + element.categoryId">
                                <button class="btn btn-outline-dark" type="button">
                                  <div class="row justify-content-end">
                                    <div class="col-4">
                                      {{ element.categoryName }}
                                    </div>
                                    <div class="col-4">
                                      <i class="fa-solid fa-chevron-down"></i>
                                    </div>
                                  </div>
                                </button>
                              </div>
                              <div :id="element.categoryId" class="collapse mt-1 mb-2">
                                <div class="border mt-2">
                                  <ul class="mt-2" style="list-style-type: none">
                                    <li v-for="(elementDetails, index) in element.elements"
                                        :key="index">
                                      <input :id="elementDetails.id" v-model="sectionPagesChildren"
                                             :value="elementDetails"
                                             class="form-check-input"
                                             name="flexRadioDefault"
                                             style="width: 15px; height: 15px;"
                                             type="checkbox">
                                      <h5 class="ms-1">
                                        {{ elementDetails.title }}
                                      </h5>

                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <div class="btn btn-info btn-sm mb-2" @click="addSectionLink()">
                            <!--                        <div v-if="collectionLinksChildren.length == 0"> Add a Link</div>-->
                            <!--                        <div v-else>Add another Link</div>-->
                            <div>Add a Link</div>
                          </div>
                          <div class="main-section d-flex flex-column" style="display: flex">
                            <div v-for="(linkSection, index) in sectionLinkChildren" :key="index">
                              <div v-if="linkSection.page_type == 3"
                                   class="border border-secondary rounded p-2 mt-2 mb-2">
                                <div>Link {{ index + 1 }}</div>
                                <input v-model="linkSection.menu_name_bn" class="form-control mb-2"
                                       placeholder="Add title"
                                       type="text"/>
                                <input v-model="linkSection.menu_name_en" class="form-control mb-2"
                                       placeholder="Add English title"
                                       type="text"/>
                                <input v-model="linkSection.external_link" class="form-control"
                                       placeholder="Add a Link"
                                       type="text"/>
                                <div class="d-flex flex-row mt-2">
                                  <div class="btn btn-secondary me-1 btn-sm"
                                       @click="removeSectionCollectionLinkData(index)">
                                    Remove
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-primary" data-bs-dismiss="modal"
                            type="button"
                            @click="addSection">Add
                    </button>
                    <button class="btn btn-danger btn-lg" data-bs-dismiss="modal"
                            type="button"
                            @click="cancelSection">Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showUpdateModal">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;"
                 tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Update a Section
                    </h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                            type="button" @click="showUpdateModal = false"></button>
                  </div>
                  <!-- Section Details-->
                  <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                    <div class="main-section d-flex flex-column" style="display: flex">
                      <div class="d-flex flex-row gap-3 mb-2">
                        <div class="d-flex flex-column w-100">
                          <div class="h6 ms-1 mb-2">Section Title</div>
                          <input
                              v-model="this.menuStructure[this.toUpdateMenuIndex].children[toUpdateSectionMenuIndex].menu_name_bn"
                              class="form-control mb-2"
                              placeholder="Section title"
                              type="text"/>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <div class="h6 ms-1 mb-2">Section English Title</div>
                          <input
                              v-model="this.menuStructure[this.toUpdateMenuIndex].children[toUpdateSectionMenuIndex].menu_name_en"
                              class="form-control mb-2"
                              placeholder="Section English title"
                              type="text"/>
                        </div>
                      </div>
                      <div class="d-flex flex-row gap-3 w-100">
                        <div class="d-flex flex-column w-100">
                          <div class="btn btn-success btn-sm mb-2"
                               @click="showPageSection = !showPageSection">
                            Edit Pages
                          </div>
                          <div v-if="showPageSection">
                            <div v-for="(categoryinfo, index) in subcategoriesInfo" :key="index"
                                 class="mx-2 my-2">
                              <div :aria-controls="categoryinfo.categoryId" aria-expanded="false"
                                   class="d-grid gap-2" data-bs-toggle="collapse"
                                   v-bind:href="'#cat' + categoryinfo.categoryId">
                                <button class="btn btn-outline-dark" type="button">
                                  <div class="row justify-content-end">
                                    <div class="col-4">
                                      {{ categoryinfo.categoryName }} Categories
                                    </div>
                                    <div class="col-4">
                                      <i class="fa-solid fa-chevron-down"></i>
                                    </div>
                                  </div>
                                </button>
                              </div>
                              <div v-bind:id="'cat' + categoryinfo.categoryId" class="collapse mt-1 mb-2">
                                <div class="border mt-2">
                                  <ul class="mt-2" style="list-style-type: none">
                                    <li v-for="(subCategoryInfo, index) in categoryinfo.subCategories"
                                        :key="index">
                                      <input v-model="updatableSectionPagesIds"
                                             :value="subCategoryInfo.id"
                                             class="form-check-input"
                                             name="flexRadioDefault"
                                             style="width: 15px; height: 15px;"
                                             type="checkbox"
                                             @change="updateSectionPageSubCategory(subCategoryInfo,subCategoryInfo.id)"
                                      >
                                      <h5 class="ms-1">
                                        {{ subCategoryInfo.name }}
                                      </h5>
                                    </li>

                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div v-for="(element, index) in elementsInfo" :key="index" class="mx-2 my-2">
                              <div :aria-controls="element.categoryId" aria-expanded="false"
                                   class="d-grid gap-2" data-bs-toggle="collapse"
                                   v-bind:href="'#' + element.categoryId">
                                <button class="btn btn-outline-dark" type="button">
                                  <div class="row justify-content-end">
                                    <div class="col-4">
                                      {{ element.categoryName }}
                                    </div>
                                    <div class="col-4">
                                      <i class="fa-solid fa-chevron-down"></i>
                                    </div>
                                  </div>
                                </button>
                              </div>
                              <div :id="element.categoryId" class="collapse mt-1 mb-2">
                                <div class="border mt-2">
                                  <ul class="mt-2" style="list-style-type: none">
                                    <li v-for="(elementDetails, index) in element.elements"
                                        :key="index">
                                      <input :id="elementDetails.id" v-model="updatableSectionPagesIds"
                                             :value="elementDetails.id"
                                             class="form-check-input"
                                             name="flexRadioDefault"
                                             style="width: 15px; height: 15px;"
                                             type="checkbox"
                                             @change="updateSectionPageContent(elementDetails,elementDetails.id)"
                                      >
                                      <h5 class="ms-1">
                                        {{ elementDetails.title }}
                                      </h5>

                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <div class="btn btn-info btn-sm mb-2" @click="addSectionLinkInUpdate()">
                            <!--                        <div v-if="collectionLinksChildren.length == 0"> Add a Link</div>-->
                            <!--                        <div v-else>Add another Link</div>-->
                            <div>Add a Link</div>
                          </div>
                          <div class="main-section d-flex flex-column" style="display: flex">
                            <div
                                v-for="(linkSection, index) in this.menuStructure[this.toUpdateMenuIndex]
                                .children[toUpdateSectionMenuIndex].children"
                                :key="index">
                              <div v-if="linkSection.page_type == 3"
                                   class="border border-secondary rounded p-2 mt-2 mb-2">
                                <div>Link {{ index + 1 }}</div>
                                <input v-model="linkSection.menu_name_bn" class="form-control mb-2"
                                       placeholder="Add title"
                                       type="text"/>
                                <input v-model="linkSection.menu_name_en" class="form-control mb-2"
                                       placeholder="Add English title"
                                       type="text"/>
                                <input v-model="linkSection.external_link" class="form-control"
                                       placeholder="Add a Link"
                                       type="text"/>
                                <div class="d-flex flex-row mt-2">
                                  <div class="btn btn-secondary me-1 btn-sm"
                                       @click="removeSectionCollectionLinkDataInUpdate(index)">
                                    Remove
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-primary" data-bs-dismiss="modal"
                            type="button"
                            @click="updateSection">Update
                    </button>
                    <!--                    <button class="btn btn-danger btn-lg" data-bs-dismiss="modal"-->
                    <!--                            type="button"-->
                    <!--                            @click="cancelSection">Cancel-->
                    <!--                    </button>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- RIGHTBAR  -->
      <div class="col-lg-7 col-md-7 ">
        <div class="bg-white rounded border  px-3 py-3">
          <div v-if="loading">
            <div class="d-flex justify-content-center">
              <div class="spinner-border " role=" status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <h4 class="mb-4">{{ selectedMenuOption.menu_name_bn }} Structure</h4>
            <div class="btn btn-primary mb-3 mx-2" @click="updateNavbarMenus">Update Position</div>
            <draggable v-model="menuStructure" :animation="300" item-key="firstLayer"
                       style="list-style-type: none;" @change="clearData">
              <template #item="{ element: menu}">
                <div>
                  <li>
                    <div class="border border-primary px-2 py-2 rounded h3 d-flex flex-row"
                         style="cursor: pointer; ">
                      <div class="d-flex  align-self-center">
                        <i class="fa-solid fa-grip-lines-vertical me-3"
                           style="color: rgb(88, 88, 88);height: 12px;"></i>
                      </div>
                      <div class="mr-auto" style="text-wrap: wrap;">
                        {{ menu.menu_name_bn }}
                      </div>
                      <div b-tooltip.hover.lefttop class="d-flex  align-self-center"
                           title="Edit this menu" @click="selectUpdatableData(menu)">
                        <i class="fa-regular fa-pen-to-square me-3"
                           style="color: rgb(52, 85, 248);height: 14px;">
                        </i>
                      </div>
                      <div b-tooltip.hover.lefttop class="d-flex  align-self-center" title="Delete this menu"
                           @click="deleteNavBarMenu(menu)">
                        <i class="fa-regular fa-trash-can me-3"
                           style="color: rgb(253, 60, 60);height: 14px;">
                        </i>
                      </div>
                    </div>
                  </li>
                  <div v-if="menu.page_type == 4" class="ms-4">
                    <draggable v-model="menu.children" :animation="300" item-key="secondLayer"
                               style="list-style-type: none;">
                      <template #item="{ element: submenu}">
                        <div>
                          <li>
                            <div class="border border-secondary px-2 py-2 rounded h5 d-flex flex-row"
                                 style="cursor: pointer; ">
                              <div class="d-flex align-self-center">
                                <i class="fa-solid fa-grip-lines-vertical me-3"
                                   style="color: rgb(155, 155, 155);height: 8px;"></i>
                              </div>
                              <div class="mr-auto" style="color: rgb(80, 77, 77);">
                                {{ submenu.menu_name_bn }}
                              </div>

                              <router-link v-if="submenu.page_type == 2"
                                           :to="'/' + categoryIdToNameConverter(submenu.category_id) + '/edit/' + submenu.page_type_id"
                                           class="d-flex align-self-center me-2">
                                <i b-tooltip.hover.lefttop class="fa-solid fa-share"
                                   style="color: rgb(122, 144, 255); height: 12px;"
                                   title="Go to this content">
                                </i>
                              </router-link>
                              <router-link v-else-if="submenu.page_type == 1"
                                           :to="'/' + categoryIdToNameConverter(submenu.category_id) + '/categories'"
                                           class="d-flex align-self-center me-2">
                                <i b-tooltip.hover.lefttop class="fa-solid fa-share"
                                   style="color: rgb(122, 144, 255); height: 12px;"
                                   title="Go to this content">
                                </i>
                              </router-link>
                              <div b-tooltip.hover.lefttop
                                   class="d-flex  align-self-center" title="Delete this sub-menu"
                                   @click="deleteNavBarMenu(submenu)">
                                <i class="fa-solid fa-eraser me-3"
                                   style="color: rgb(253, 60, 60);height: 12px;">
                                </i>
                              </div>
                            </div>
                          </li>
                          <div v-if="submenu.page_type == 4" class="ms-4">
                            <draggable v-model="submenu.children" :animation="300" item-key="thirdLayer"
                                       style="list-style-type: none;">
                              <template #item="{ element: thirdLayerMenu }">
                                <li>
                                  <div class="border border-secondary px-2 py-2 rounded h5 d-flex flex-row"
                                       style="cursor: pointer; ">
                                    <div class="d-flex align-self-center">
                                      <i class="fa-solid fa-grip-lines-vertical me-3"
                                         style="color: rgb(155, 155, 155);height: 8px;"></i>
                                    </div>
                                    <div class="mr-auto" style="color: rgb(80, 77, 77);">
                                      {{ thirdLayerMenu.menu_name_bn }}
                                    </div>

                                    <router-link v-if="thirdLayerMenu.page_type == 2"
                                                 :to="'/' + categoryIdToNameConverter(thirdLayerMenu.category_id) + '/edit/' + thirdLayerMenu.page_type_id"
                                                 class="d-flex align-self-center me-2">
                                      <i b-tooltip.hover.lefttop class="fa-solid fa-share"
                                         style="color: rgb(122, 144, 255); height: 12px;"
                                         title="Go to this content">
                                      </i>
                                    </router-link>
                                    <router-link v-else-if="thirdLayerMenu.page_type == 1"
                                                 :to="'/' + categoryIdToNameConverter(thirdLayerMenu.category_id) + '/categories'"
                                                 class="d-flex align-self-center me-2">
                                      <i b-tooltip.hover.lefttop class="fa-solid fa-share"
                                         style="color: rgb(122, 144, 255); height: 12px;"
                                         title="Go to this content">
                                      </i>
                                    </router-link>
                                    <div b-tooltip.hover.lefttop
                                         class="d-flex  align-self-center" title="Delete this sub-menu"
                                         @click="deleteNavBarMenu(thirdLayerMenu)">
                                      <i class="fa-solid fa-eraser me-3"
                                         style="color: rgb(253, 60, 60);height: 12px;">
                                      </i>
                                    </div>
                                  </div>
                                </li>
                              </template>
                            </draggable>
                          </div>
                        </div>
                      </template>
                    </draggable>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import portalMenuService from '@/services/portal-menu.service';
import {notify} from "@kyvg/vue3-notification";
import draggable from 'vuedraggable';
import {VBTooltip} from "bootstrap-vue-3";

export default {
  name: "PortalMainmenuConfigPage",
  components: {
    "draggable": draggable,
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Menu',
          to: '/notice'
        }
      ],
      selectedMenuOption: null,
      collectionPagesChildren: [],
      collectionSectionsChildren: [],
      collectionLinksChildren: [],
      sectionLinkChildren: [],
      sectionPagesChildren: [],
      updatablePagesIds: [],
      updatableSectionPagesIds: [],
      loading: false,
      showPage: false,
      showPageSection: false,
      isAddMenuEnabled: false,
      selectedElement: null,
      subcategoriesInfo: null,
      elementsInfo: null,
      menuStructure: null,
      showSection: null, //page, link, collection
      addToCollection: null, //link, page
      requestSaveNavBar: {},
      showUpdateSection: false,
      toUpdateMenuIndex: null,
      toUpdateSectionMenuIndex: null,
      toUpdateMenu: {},
      menuCategoryTypes: [],
      showAddModal: false,
      showUpdateModal: false,
      addSectionDetails: {},
      showUpdatePageMenus: false,
    };
  },
  created() {
    try {
      this.getInitData();
    } catch (error) {
      this.loading = false;
    }
  },
  methods: {
    clearData() {
      this.showPage = false;
      this.collectionLinksChildren = [];
      this.sectionLinkChildren = [];
      this.selectedElement = null;
      this.requestSaveNavBar = {};
      this.collectionPagesChildren = [];
      this.isAddMenuEnabled = false;
      this.showSection = null;
      this.addToCollection = null;
      this.showUpdateSection = false;
      this.toUpdateMenuIndex = null;
      this.updatablePagesIds = [];
      this.addSectionDetails = {};
      this.showUpdatePageMenus = false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async getInitData() {
      try {
        this.loading = true;
        const menuCategoryResponse = await portalMenuService.getMenuCategories();
        if (menuCategoryResponse.data != null) {
          this.menuCategoryTypes = menuCategoryResponse.data;
          this.selectedMenuOption = this.menuCategoryTypes[0];
        } else {
          this.loading = false;
        }
        const response = await portalMenuService.getSubCategories();
        if (response.data != null) {
          this.subcategoriesInfo = response.data;
        }
        const second_response = await portalMenuService.getElements();
        if (second_response.data != null) {
          this.elementsInfo = second_response.data;
        }
        this.loading = false;
        await this.getPortalMenus(this.selectedMenuOption.l_portal_menu_type_id);
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async toggleMenuType() {
      this.clearData();
      this.menuStructure = [];
      await this.getPortalMenus(this.selectedMenuOption.l_portal_menu_type_id);
    },
    async updateCheckBox(id, subcatOrContent, data) {
      await new Promise(resolve => setTimeout(resolve, 100));
      if (this.updatablePagesIds.includes(id)) {
        if (subcatOrContent == 'subcat') {
          this.menuStructure[this.toUpdateMenuIndex].children.push(
              {
                "menu_name_bn": data.name,
                "menu_name_en": data.name_en,
                navbar_menu_id: this.menuStructure[this.toUpdateMenuIndex].menu_id,
                "page_type": 1,
                "page_type_id": id,
                "position": this.menuStructure[this.toUpdateMenuIndex].children.length,
                "active_yn": "Y",
                "external_link": null,
                "slug": data.slug,
                "category_id": data.category_id,
              }
          );
        } else {
          this.menuStructure[this.toUpdateMenuIndex].children.push(
              {
                "menu_name_bn": data.title,
                "menu_name_en": data.title_en,
                navbar_menu_id: this.menuStructure[this.toUpdateMenuIndex].menu_id,
                "page_type": 2,
                "page_type_id": id,
                "position": this.menuStructure[this.toUpdateMenuIndex].children.length,
                "active_yn": "Y",
                "external_link": null,
                "slug": data.slug,
                "category_id": data.category_id,
              }
          );
        }
      } else {
        for (var i = this.menuStructure[this.toUpdateMenuIndex].children.length - 1; i >= 0; --i) {
          if (this.menuStructure[this.toUpdateMenuIndex].children[i].page_type_id == id) {
            this.menuStructure[this.toUpdateMenuIndex].children.splice(i, 1);
          }
        }
      }
    },
    selectUpdatableData(data) {
      this.scrollToTop();
      this.showUpdateSection = true;
      this.toUpdateMenuIndex = this.menuStructure.indexOf(data);
      if (data.page_type == 4) {
        data.children.forEach(element => {
          if (element.page_type == 1 || element.page_type == 2) {
            this.updatablePagesIds.push(element.page_type_id);
          }

          // element.children.forEach(thirdChild => {
          //
          // })
        });
      }
    },
    selectUpdatableSectionData(data) {
      this.addSectionDetails = {};
      this.showUpdateModal = true;
      this.showUpdateSection = true;
      this.toUpdateSectionMenuIndex = this.menuStructure[this.toUpdateMenuIndex].children.indexOf(data);
      this.updatableSectionPagesIds = [];
      this.sectionLinkChildren = [];

      if (data.page_type == 4) {
        data.children.forEach(element => {
          if (element.page_type == 1 || element.page_type == 2) {
            this.updatableSectionPagesIds.push(element.page_type_id);
          } else if (element.page_type == 3) {
            this.sectionLinkChildren.push(element);
          }
        });
      }
    },
    selectContent(contentDetails) {
      this.requestSaveNavBar.menu_name_bn = contentDetails.title;
      this.requestSaveNavBar.menu_name_en = contentDetails.title_en;
      this.requestSaveNavBar.page_type = 2;
      this.requestSaveNavBar.page_type_id = contentDetails.id;
      this.requestSaveNavBar.slug = contentDetails.slug;
      this.requestSaveNavBar.category_id = contentDetails.category_id;
    },
    selectSubCategory(subcatDetails) {
      this.requestSaveNavBar.menu_name_bn = subcatDetails.name;
      this.requestSaveNavBar.menu_name_en = subcatDetails.name_en;
      this.requestSaveNavBar.page_type = 1;
      this.requestSaveNavBar.page_type_id = subcatDetails.id;
      this.requestSaveNavBar.slug = subcatDetails.slug;
      this.requestSaveNavBar.category_id = subcatDetails.category_id;
    },
    updateSinglePageContent(contentDetails) {
      this.menuStructure[this.toUpdateMenuIndex].menu_name_bn = contentDetails.title;
      this.menuStructure[this.toUpdateMenuIndex].menu_name_en = contentDetails.title_en;
      this.menuStructure[this.toUpdateMenuIndex].page_type = 2;
      this.menuStructure[this.toUpdateMenuIndex].page_type_id = contentDetails.id;
      this.menuStructure[this.toUpdateMenuIndex].slug = contentDetails.slug;
      this.menuStructure[this.toUpdateMenuIndex].category_id = contentDetails.category_id;
    },
    updateSinglePageSubCategory(subcatDetails) {
      this.menuStructure[this.toUpdateMenuIndex].menu_name_bn = subcatDetails.name;
      this.menuStructure[this.toUpdateMenuIndex].menu_name_en = subcatDetails.name_en;
      this.menuStructure[this.toUpdateMenuIndex].page_type = 1;
      this.menuStructure[this.toUpdateMenuIndex].page_type_id = subcatDetails.id;
      this.menuStructure[this.toUpdateMenuIndex].slug = subcatDetails.slug;
      this.menuStructure[this.toUpdateMenuIndex].category_id = subcatDetails.category_id;
    },
    updateSectionPageContent(contentDetails, elementId) {
      const childIndex = this.toUpdateSectionMenuIndex;
      let toDeleteObject = [];
      toDeleteObject = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.filter(function (obj) {
        return obj.page_type_id == elementId;
      });
      if (toDeleteObject && toDeleteObject.length) {
        let toDeleteObjectIndex = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.indexOf(toDeleteObject[0]);
        this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.splice(toDeleteObjectIndex, 1);
      } else {
        this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.push({
          page_type_id: elementId.id,
          page_type: 2
        });
        let thirdLayerChildIndex = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.length - 1;
        let toAddElement = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex];
        toAddElement.menu_name_bn = contentDetails.title;
        toAddElement.menu_name_en = contentDetails.title_en;
        toAddElement.page_type = 2;
        toAddElement.page_type_id = contentDetails.id;
        toAddElement.slug = contentDetails.slug;
        toAddElement.category_id = contentDetails.category_id;
        //
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.push({});
        // let thirdLayerChildIndex = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.length - 1;
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex].menu_name_bn = contentDetails.title;
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex].menu_name_en = contentDetails.title_en;
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex].page_type = 2;
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex].page_type_id = contentDetails.id;
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex].slug = contentDetails.slug;
        // this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex].category_id = contentDetails.category_id;
      }
    },
    updateSectionPageSubCategory(subcatDetails, categoryId) {
      const childIndex = this.toUpdateSectionMenuIndex;
      let toDeleteObject = [];
      toDeleteObject = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.filter(function (obj) {
        return obj.page_type_id == categoryId;
      });
      if (toDeleteObject && toDeleteObject.length) {
        let toDeleteObjectIndex = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.indexOf(toDeleteObject[0]);
        this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.splice(toDeleteObjectIndex, 1);
      } else {
        this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.push({
          page_type_id: subcatDetails.id,
          page_type: 1
        });
        let thirdLayerChildIndex = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children.length - 1;
        let toAddElement = this.menuStructure[this.toUpdateMenuIndex].children[childIndex].children[thirdLayerChildIndex];
        toAddElement.menu_name_bn = subcatDetails.name;
        toAddElement.menu_name_en = subcatDetails.name_en;
        toAddElement.page_type = 1;
        toAddElement.page_type_id = subcatDetails.id;
        toAddElement.slug = subcatDetails.slug;
        toAddElement.category_id = subcatDetails.category_id;
      }
    },
    addSectionLink() {
      this.sectionLinkChildren.push(
          {
            menu_name_bn: null,
            menu_name_en: null,
            page_type: 3,
            page_type_id: null,
            position: this.sectionLinkChildren.length,
            // "active_yn": "Y",
            external_link: null,
          }
      )
    },
    addSectionLinkInUpdate() {
      this.menuStructure[this.toUpdateMenuIndex]
          .children[this.toUpdateSectionMenuIndex].children.push(
          {
            menu_name_bn: null,
            menu_name_en: null,
            page_type: 3,
            page_type_id: null,
            external_link: null,
          }
      )
    },
    addLink() {
      this.collectionLinksChildren.push(
          {
            menu_name_bn: null,
            "menu_name_en": null,
            "page_type": 3,
            "page_type_id": null,
            "position": this.collectionLinksChildren.length,
            // "active_yn": "Y",
            "external_link": null,
          }
      )
    },
    updateSection() {
      this.showUpdateModal = false;
      // this.toUpdateSectionMenuIndex = null;
      // this.toUpdateMenuIndex = null;
      // this.addSectionDetails = {};
      // this.sectionLinkChildren = [];
      // this.sectionPagesChildren = [];
    },
    addSection() {
      this.showAddModal = false;
      this.addSectionDetails.page_type = 4;
      const children = [];
      this.sectionPagesChildren.forEach(element => {
        if (element.name == null) {
          // element
          children.push(
              {
                "menu_name_bn": element.title,
                "menu_name_en": element.title_en,
                "page_type": 2,
                "page_type_id": element.id,
                "position": children.length,
                "slug": element.slug,
                "category_id": element.category_id,
              }
          );
        } else {
          children.push(
              {
                "menu_name_bn": element.name,
                "menu_name_en": element.name_en,
                "page_type": 1,
                "page_type_id": element.id,
                "position": children.length,
                "slug": element.slug,
                "category_id": element.category_id,
              }
          );
        }
      });
      this.addSectionDetails.children = children.concat(this.sectionLinkChildren);
      //
      if (this.showUpdateSection) {
        this.menuStructure[this.toUpdateMenuIndex].children.push(this.addSectionDetails);
      } else {
        this.collectionSectionsChildren.push(this.addSectionDetails);
      }
      this.addSectionDetails = {};
      this.sectionLinkChildren = [];
      this.sectionPagesChildren = [];
    },
    cancelSection() {
      this.showAddModal = false;
      this.showUpdateModal = false;
      this.addSectionDetails = {};
    },
    openAddSectionModal() {
      this.addSectionDetails = {};
      this.showAddModal = true;
    },
    openUpdateSectionModal() {
      this.addSectionDetails = {};
      this.showUpdateModal = true;
    },
    addLinkforUpdate() {
      this.menuStructure[this.toUpdateMenuIndex].children.push(
          {
            "menu_name_bn": null,
            "menu_name_en": null,
            navbar_menu_id: this.menuStructure[this.toUpdateMenuIndex].menu_id,
            "page_type": 3,
            "page_type_id": null,
            "position": this.menuStructure[this.toUpdateMenuIndex].children.length,
            "active_yn": "Y",
            "external_link": null,
          }
      )
    },
    toggleMenuEnabled(data) {
      this.clearData();
      this.showSection = data;
      if (data == "cancel") {
        this.isAddMenuEnabled = false;
      } else {
        this.isAddMenuEnabled = true;
      }
    },
    removeAcollectionLinkDataAtUpdate(data) {
      const index = this.menuStructure[this.toUpdateMenuIndex].children.indexOf(data);
      this.menuStructure[this.toUpdateMenuIndex].children.splice(index, 1);
    },
    removeAcollectionLinkData(index) {
      this.collectionLinksChildren.splice(index, 1);
    },
    removeSectionCollectionLinkData(index) {
      this.sectionLinkChildren.splice(index, 1);
    },
    removeSectionCollectionLinkDataInUpdate(index) {
      this.menuStructure[this.toUpdateMenuIndex]
          .children[this.toUpdateSectionMenuIndex].children.splice(index, 1);
    },
    removeSection(sectionIndex) {
      this.collectionSectionsChildren.splice(sectionIndex, 1);
    },
    // removeSectionFromUpdate(mainIndex, sectionIndex) {
    //   const x = this.menuStructure[mainIndex].children.splice(sectionIndex, 1);
    // },
    async getPortalMenus(id) {
      this.loading = true;
      let menu_response;
      try {
        menu_response = await portalMenuService.getPortalMenus(id);
        this.loading = false;
        if (menu_response.data != null) {
          this.menuStructure = menu_response.data;
          // this.menuStructure.sort(this.compareByPosition);
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async updateNavbarMenus() {
      this.menuStructure.forEach((menuItem, menuIndex) => {
        menuItem.position = menuIndex;
        menuItem.menu_type_id = this.selectedMenuOption.l_portal_menu_type_id;
        if (menuItem.page_type == 4) {
          // if (menuItem.children.length == 0) {
          //   notify({
          //     type: "error",
          //     title: "Update Menu",
          //     text: "Dropdowns have to contain at least one element",
          //   });
          //   throw "exit";
          // }
          if (menuItem.children != null)
            menuItem.children.forEach((submenu, submenuIndex) => {
              if (submenu.menu_name_bn === "" || submenu.menu_name_bn == null) {
                notify({
                  type: "error",
                  title: "Update Menu",
                  text: "Submenu item name can not be empty",
                });
                throw "exit";
              }
              submenu.position = submenuIndex;
              submenu.menu_type_id = this.selectedMenuOption.l_portal_menu_type_id;

              if (submenu.children != null)
                submenu.children.forEach((thirdmenu, thirdmenuIndex) => {
                  if (thirdmenu.menu_name_bn === "" || thirdmenu.menu_name_bn == null) {
                    notify({
                      type: "error",
                      title: "Update Menu",
                      text: "Submenu item name can not be empty",
                    });
                    throw "exit";
                  }
                  thirdmenu.position = thirdmenuIndex;
                  thirdmenu.menu_type_id = this.selectedMenuOption.l_portal_menu_type_id;
                });
            });
        }
      });
      try {
        this.loading = true;
        const response = await portalMenuService.updateMenuItem(this.menuStructure);
        this.loading = false;
        if (response.data) {
          if (response.data['messageCode'] === 1) {
            notify({
              type: "success",
              title: "Update Menu",
              text: response.data.message,
            });
            await this.getPortalMenus(this.selectedMenuOption.l_portal_menu_type_id);
            this.clearData();
          } else {
            notify({
              type: "error",
              title: "Update Menu",
              text: response.data.message,
            });
          }
        }
        this.clearData();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }

    },
    async addNavBarMenu(type) {
      if (this.requestSaveNavBar.menu_name_bn == null || this.requestSaveNavBar.menu_name_bn === "") {
        notify({
          type: "error",
          title: "Error",
          text: "Name is required to add a menu",
        });
        throw 'exit';
      }
      if (this.menuStructure.length > 18) {
        notify({
          type: "error",
          title: "Error",
          text: "Menu Items can't be more than 18",
        });
        return;
      }
      if (this.menuStructure != null && this.menuStructure.length > 0) {
        var maxPosition = 0;
        this.menuStructure.forEach(menu => {
          if (menu.position > maxPosition) {
            maxPosition = menu.position;
          }
        });
        this.requestSaveNavBar.position = parseInt(maxPosition + 1);
      } else {
        this.requestSaveNavBar.position = 0;
      }

      // this.requestSaveNavBar.active_yn = 'Y';
      this.requestSaveNavBar.menu_type_id = this.selectedMenuOption.l_portal_menu_type_id;
      if (this.selectedMenuOption.l_portal_menu_type_id === 1) {
        // if (this.requestSaveNavBar.menu_name_bn.length > 19) {
        //   this.requestSaveNavBar.menu_name_bn = this.requestSaveNavBar.menu_name_bn.slice(0, 18) + "...";
        // }
        // if (this.requestSaveNavBar.menu_name_en != null && this.requestSaveNavBar.menu_name_en != "" && this.requestSaveNavBar.menu_name_en.length > 19) {
        //   this.requestSaveNavBar.menu_name_en = this.requestSaveNavBar.menu_name_en.slice(0, 18) + "...";
        // }
      }
      if (type === 'link') {
        this.requestSaveNavBar.page_type = 3;
        if (this.requestSaveNavBar.external_link == null || this.requestSaveNavBar.external_link == "") {
          notify({
            type: "error",
            title: "Error",
            text: "Link is required to add a menu",
          });
          throw 'exit';
        }
      } else if (type === 'collection') {
        this.requestSaveNavBar.page_type = 4;
        let children = [];
        this.collectionPagesChildren.forEach(element => {
          if (element.name == null) {
            // element
            if (element.title.length > 19) {
              element.title = element.title.slice(0, 18) + "...";
            }
            if (element.title_en.length > 19) {
              element.title_en = element.title_en.slice(0, 18) + "...";
            }
            children.push(
                {
                  "menu_name_bn": element.title,
                  "menu_name_en": element.title_en,
                  "page_type": 2,
                  "page_type_id": element.id,
                  "position": children.length,
                  // "active_yn": "Y",
                  "slug": element.slug,
                  "category_id": element.category_id,
                }
            );
          } else {
            // sub category
            // if (element.name.length > 19) {
            //   element.name = element.name.slice(0, 18) + "...";
            // }
            // if (element.name_en.length > 19) {
            //   element.name_en = element.name_en.slice(0, 18) + "...";
            // }
            children.push(
                {
                  "menu_name_bn": element.name,
                  "menu_name_en": element.name_en,
                  "page_type": 1,
                  "page_type_id": element.id,
                  "position": children.length,
                  // "active_yn": "Y",
                  "slug": element.slug,
                  "category_id": element.category_id,
                }
            );
          }
        });
        children = children.concat(this.collectionLinksChildren);
        children = children.concat(this.collectionSectionsChildren);
        this.requestSaveNavBar.children = children;
      }
      try {
        this.loading = true;
        const payload = {
          // menu_id: 24011612084625,
          menu_name_bn: this.requestSaveNavBar.menu_name_bn,
          menu_name_en: this.requestSaveNavBar.menu_name_en,
          slug: this.requestSaveNavBar.slug,
          page_type: this.requestSaveNavBar.page_type,
          page_type_id: this.requestSaveNavBar.page_type_id,
          // parent_menu_id:  this.requestSaveNavBar.menu_name_en,
          external_link: this.requestSaveNavBar.external_link,
          position: this.requestSaveNavBar.position,
          menu_type_id: this.requestSaveNavBar.menu_type_id,
          category_id: this.requestSaveNavBar.menu_name_en.category_id,
          menu_layer: 1,
          // insert_by: 2312191350,
          // insert_date: "2024-01-16T00:00:00",
          children: this.requestSaveNavBar.children
        };
        const response = await
            portalMenuService.saveMenuItem(payload);
        this.loading = false;
        if (response.data) {
          if (response.data['messageCode'] == 1) {
            notify({
              type: "success",
              title: "Save Menu",
              text: response.data.message,
            });
            this.requestSaveNavBar = null;
            // this.toggleMenuEnabled('cancel');
            this.getPortalMenus(this.selectedMenuOption.l_portal_menu_type_id);
            this.clearData();
          } else {
            notify({
              type: "error",
              title: "Save Menu",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.loading = false;
      }

    },
    async deleteNavBarMenu(menu) {
      if (menu.children && menu.children.length > 0) {
        notify({
          type: "error",
          title: "Delete Failed",
          text: "Please delete the submenus first before deleting this menu",
        });
        return
      }
      const result = await this.$swal({
        title: 'Are you sure, You want to Delete this Content?',
        showCancelButton: true,
        cancelButtonText: 'No',
        cancelButtonColor: '#dd3333',
        showConfirmButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#007bff',
      });
      if (result.isConfirmed) {
        this.loading = true;
        try {
          const response = await
              portalMenuService.deleteMenuItemById(menu.menu_id);
          this.loading = false;
          if (response.data) {
            if (response.data['messageCode'] == 1) {
              notify({
                type: "success",
                title: "Delete Menu Item",
                text: response.data.message,
              });
              this.getPortalMenus(this.selectedMenuOption.l_portal_menu_type_id);
            } else {
              notify({
                type: "error",
                title: "Delete Menu Item",
                text: response.data.message,
              });
            }
          }
        } catch (error) {
          this.loading = false;
        }
      }
    },
    categoryIdToNameConverter(category_id) {
      switch (category_id) {
        case 1:
          return 'posts';
        case 2:
          return 'services';
        case 3:
          return 'laws';
        case 4:
          return 'notices';
        case 5:
          return 'pages';
        case 6:
          return 'faqs';
        case 7:
          return 'products';
        case 8:
          return 'managements';
        default:
          break;
      }
    }
  },
};
</script>

<style scoped>
.rightBar {
  width: 60%;
  margin-bottom: 10px;
  background-color: white;
}

.leftBar {
  width: 40%;
  margin-bottom: 10px;
  background-color: white;
}
</style>
